import React, { FC } from "react";
import { Skeleton } from "@mui/material";

interface SkeletonTableRowsProps {
    rows?: number;
    // Height of a loaded row of that table, so nothing jumps when the rows arrive.
    rowHeight?: number;
    // colSpan of each cell, in column order (e.g. [2, 2, 1, 1]); one cell per entry.
    columns: number[];
    // Button-sized blocks in the last cell, for tables whose last column holds action buttons (sets the row height).
    actionButtons?: number;
}

// Placeholder rows for plain tables while their data loads, the same as the shared grid and the invoices table.
const SkeletonTableRows: FC<SkeletonTableRowsProps> = ({ rows = 5, rowHeight, columns, actionButtons = 0 }) => (
    <>
        {Array.from({ length: Math.max(1, rows) }).map((_, row) => (
            <tr key={"skeleton-" + row} className="pb-grid-skeleton-row" style={rowHeight ? { height: rowHeight } : undefined}>
                {columns.map((span, column) => (
                    <td key={column} colSpan={span}>
                        {actionButtons > 0 && column === columns.length - 1 ? (
                            <div className="pb-skeleton-actions" style={{ justifyContent: "flex-start" }}>
                                {Array.from({ length: actionButtons }).map((__, button) => (
                                    <Skeleton key={button} variant="rounded" width={40} height={40} />
                                ))}
                            </div>
                        ) : (
                            <Skeleton variant="text" height={20} width="80%" />
                        )}
                    </td>
                ))}
            </tr>
        ))}
    </>
);

export default SkeletonTableRows;
